import { SimpleCatchError } from "../../utils/Helper";
import { Axios } from "../../utils/axiosMiddleware";
import { sendChatMessageViaContract } from "../../sockets/ChatSockets";
/**
 * The server refuses the accept when the payer has not yet paid for a contract
 * their gigster sent them — that money is taken at accept, not held on send. It
 * is a prompt to pay, not a failure, so the caller charges and retries instead
 * of showing an error about someone else's payment (GIG-132).
 */
export const PAYMENT_REQUIRED_BEFORE_ACCEPT = "PAYMENT_REQUIRED_BEFORE_ACCEPT";

const needsPaymentFirst = (e) =>
  e?.response?.data?.code === PAYMENT_REQUIRED_BEFORE_ACCEPT;

export const ContractAcceptRequest = async (payload, dispatch, navigate) => {
  try {
    const token = JSON.parse(localStorage.getItem("data"));
    const { contract_Id } = payload;
    await Axios.patch(`message-files/contract_status/${contract_Id}/receive`, {
      user_id: token?.user_id,
      user_type: token?.user_type,
    });
    if (typeof navigate === "function") {
      navigate("/contract-lists");
    }
    return true;
  } catch (e) {
    // Report this one case up so the caller can open the payment sheet; every
    // other failure keeps its existing toast.
    if (needsPaymentFirst(e)) {
      return { paymentRequired: true };
    }
    SimpleCatchError(e);
    return false;
  }
};

export const ContractRejectRequest = async (payload, dispatch, navigate) => {
  try {
    const token = JSON.parse(localStorage.getItem("data"));
    const { contract_Id, status, secondary_status } = payload;
    await Axios.patch(
      `message-files/contract_status/${contract_Id}/${status}`,
      {
        user_id: token?.user_id,
        user_type: token?.user_type,
        secondary_status,
      }
    );
    navigate("/contract-lists");
  } catch (e) {
    SimpleCatchError(e);
  }
};

export const UpdateContractStatusRequest = async (
  payload,
  navigate,
  contractDetail,
  intl
) => {
  try {
    const token = JSON.parse(localStorage.getItem("data"));
    const { contract_Id, disputeReason, claimedAmount } = payload;
    // Claimant fields belong to the dispute row only — this helper also serves the
    // assigned/not_assigned status changes, which must keep their original body.
    // claimedAmount is sent only as a number: @IsNumber behind a whitelisting pipe.
    const disputeFields =
      payload?.status === "disputed"
        ? {
            claimantUserId: token?.user_id,
            claimantRole: token?.user_type,
            ...(typeof claimedAmount === "number" &&
            Number.isFinite(claimedAmount)
              ? { claimedAmount }
              : {}),
          }
        : {};
    await Axios.patch(
      `/message-files/contract_status/${payload?.contract_Id}/${payload?.status}`,
      {
        reason: disputeReason,
        user_id: token?.user_id,
        user_type: token?.user_type,
        ...disputeFields,
      }
    );

    if (status === "assigned") {
      const conversation = await Axios.post(
        `/message-files/conversation/${token.id}/${
          contractDetail?.contractorId
            ? contractDetail?.contractorId
            : contractDetail?.tradesmanId
        }/${token.user_type}/${
          contractDetail?.contractorId ? "contractor" : "tradesman"
        }/0/0`,
        {}
      );

      if (conversation?.data?.id) {
        sendChatMessageViaContract({
          message: `${intl.formatMessage({
            id: "CONTRACT_HAS_BEEN_ASSIGNED",
          })} ${contract_Id}`,
          sender: token?.id,
          receiver: contractDetail?.contractorId
            ? contractDetail?.contractorId
            : contractDetail?.tradesmanId,
          room: conversation?.data?.id,
          type: "work_request",
          user_type: token.user_type,
          receiver_type: contractDetail?.contractorId
            ? "contractor"
            : "tradesman",
        });
      }
    }
    navigate("/contract-lists");
  } catch (e) {
    SimpleCatchError(e);
  }
};

export const UpdateContractRequest = async (payload, navigate) => {
  try {
    const token = JSON.parse(localStorage.getItem("data"));
    const {
      contract_Id,
      secondary_status,
      isSubContract,
      subContractId,
      line_items,
      start_date,
      end_date,
    } = payload;

    await Axios.patch(`/message-files/contract/change/request/${contract_Id}`, {
      user_id: token?.user_id,
      user_type: token?.user_type,
      secondary_status,
      isSubContract,
      subContractId,
      line_items,
      start_date,
      end_date,
    });

    navigate("/contract-lists");
  } catch (e) {
    SimpleCatchError(e);
  }
};

export const AcceptQuickContractRequest = async (payload, navigate) => {
  try {
    await Axios.post(`message-files/contract/paid`, payload);
    navigate("/contract-lists");
  } catch (e) {
    SimpleCatchError(e);
  }
};

export const AwardToMyselfSaga = async (payload, dispatch, navigate) => {
  try {
    const token = JSON.parse(localStorage.getItem("data"));
    const { contract_Id } = payload;
    await Axios.post(`/message-files/transfer/contract-to-tradesman/account`, {
      contractId: contract_Id,
      userId: token?.user_id,
    });
    navigate("/contract-lists");
  } catch (e) {
    SimpleCatchError(e);
  }
};
